import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

const DialogWrapper = ({ children, actions, heading, open, onClose, ...props }) => {
  return (
    <Dialog open={open} onClose={onClose} style={{ padding: 16, ...props.style }} {...props}>
      {heading && (
        <DialogTitle style={{ marginTop: 8, padding: '8px 24px' }}>{heading}</DialogTitle>
      )}
      <DialogContent style={{ padding: '5px 0px 2px 0px', margin: '10px 20px' }}>
        {children ? children : <p>Pass children to render</p>}
      </DialogContent>
      {actions && (
        <DialogActions style={{ padding: '20px 24px' }}>
          {actions ? actions : <p> Pass actions in action prop</p>}
        </DialogActions>
      )}
    </Dialog>
  )
}

export default DialogWrapper
